<template>
    <Button
        class="campaign-edit__header-action-btn campaign-edit__header-action-btn--add-language"
        data-testid="editor-header__add-language-button"
        @click="languageModalVisible = true"
    >
        Add Language
    </Button>
    <CampaignLanguagesModal
        v-if="languageModalVisible"
        :visible="languageModalVisible"
        @update="onLanguageUpdate"
        @close="languageModalVisible = false"
    />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CampaignLanguagesModal from "@/components/Campaign/CampaignLanguagesModal.vue";
import bus from "@/bus";
import type { LanguageCode } from "@/utils/languages";
import { updateLanguages } from "@/services/Language";

export default defineComponent({
    name: "AddLanguage",
    components: { CampaignLanguagesModal },

    data() {
        return {
            languageModalVisible: false
        };
    },

    computed: {
        campaignId() {
            return this.$route.params.campaignId as string;
        }
    },

    methods: {
        async onLanguageUpdate(languages: LanguageCode[]) {
            try {
                this.$snackbar.info("Updating Languages...");

                await updateLanguages(this.campaignId, languages);

                this.$snackbar.success("Languages updated.");
            } catch (e) {
                this.$snackbar.error("We could not update languages", `\n${e as string}`, {
                    duration: 0,
                    closable: true
                });
            } finally {
                bus.$emit("percentLoadEvent", 100);
            }
        }
    }
});
</script>
